import React from 'react'
import styles from './cell-text.styles'
import injectSheet from 'react-jss'

const CellText = ({ classes, children }) => (
  <span className={classes.container}>{children}</span>
)

export default injectSheet(styles)(CellText)
